<template>
  <div class="author" v-if="user?.name">
    <div class="author__media" v-if="user?.image">
      <AtomImage class="object-cover" :src="user.image?.url" :alt="user.image?.alt || user?.name" v-if="user?.image" />
    </div>
    <div class="author__info">
      <div class="author__name" v-html="user.name" />
      <!-- <div class="author__meta" v-if="post?.publishDate">
        <AtomPostDate :created-at="post.publishDate" :updated-at="post.modifiedDate" />
      </div> -->
      <div class="author__meta">
        <AtomIcon name="calendar" class="-mt-px" />
        {{ toDayjs(post.modifiedDate).format('D MMMM YYYY') }}
      </div>
    </div>
    <!-- <div class="debug text-xs">{{ post }}</div> -->
    <!-- <div class="debug text-xs">{{ block }}</div> -->
  </div>
</template>

<script setup>
const route = useRoute()

const props = defineProps({
  block: Object
})

// Grep data
const user = props.block?.data?.user

// Grep post from nuxt data
const { data: post } = useNuxtData(`post-${route.path}`)
</script>

<style lang="scss" scoped>
.author {
  @apply my-4 max-w-3xl;
  @apply flex items-center gap-3 md:gap-4; 
  @apply border-t pt-8 pb-12;

  &__media {
    @apply w-12 h-12 md:w-16 md:h-16 aspect-square;
    @apply rounded-full overflow-hidden;
  }

  &__info {

  }

  &__name {
    @apply font-medium;
  }

  &__meta {
    @apply text-sm text-[#888] flex items-center gap-2;
  }
}
</style>